'use strict'
const _ = require('lodash');
const $ = require('jquery');
const PubSub = require('./../PubSub');
const ModelConnect = require('tscom-connect');

// constants
const CONNECT = require( '../constants').CONNECT;

module.exports = ModelConnect.extend({
    /**
     * [defaults description]
     * @type {Object}
     */
    defaults: {
        apiKey: '',
        secretKey: '',
        version_id: '',

        requestActionGetPayload: null,
        getFailureCount: 0,
        getFailureLimit: 3,

        // vote (read-write) request fields
        requestActionVotePayload: null,
        requestActionVoteError: null,

        shareString: null
    },
    /**
     * Internal options and values
     */
    versionCheck: CONNECT.CONNECT_VERSION_CHECK,
    requestActionGetXhr: null,
    getTimer: null,
    getIntervalTimer: null,

    /**
     * Initialize
     * @param  {Object} attr    [description]
     * @param  {Object} options [description]
     */
    initialize: function(attr, options) {
        _.bindAll(this, 'syncSuccess', 'syncError');
        this.cms = options.cms;
        this.getContextData = options.getContextData;
        this.getUserData = options.getUserData;
        this.secretKey = options.secretKey;
        this.version_id = options.version_id;
        this.numberOfCategories = options.numberOfCategories;
    },
    /**
     *
     */
    requestActionGet: function() {
        var data = _.extend(this.getContextData(), { apiKey: this.get('apiKey'), action_type: 'get'}, this.getUserData());

        var params = this.paramsLiteralToQsp(data);
        var b64hash = this.qspToHash(params);
        var xhrParams = {
            url: this.apiUrl + '?' + params,
            type: 'POST',
            crossDomain: true,
            dataType: 'json',
            data: 'Authorization=' + encodeURIComponent(b64hash),
            success: this.actionTypeGetSuccess.bind(this),
            error: this.actionTypeGetError.bind(this)
        };

        this.getTimer = window.setTimeout(this.retryActionGet.bind(this), 7000);
        return this.requestActionGetXhr = $.ajax(xhrParams);
    },
    /**
     *
     * @param data
     * @param textStatus
     * @param jqXHR
     */
    actionTypeGetSuccess: function (data, textStatus, jqXHR) {      
      if(!(_.isObject(data) && _.size(data) > 0)){
        return console.log('requestActionGetSuccess - Invalid Data Payload');
      }

      // clear timer on GET request and set to null
      clearTimeout(this.getTimer);
      this.getTimer = null;
      
      // silently prepare for next GET request
      this.set({
        requestActionGetPayload: 0,
        getFailureCount: 0
      }, { silent: true });
      if(this.cms.get('appState') !== 'open') return;

      switch(data.response_code) {
        case '20':
          var payload = null;
          if( data.votestring && data.votestring.length > 0 ) {
              payload = unpadVoteStringCategoryIds( data.votestring );
          } else if ( data.turbo_window ) {
              payload = {
                  turbo_window: data.turbo_window
              }
          }
          this.set({ requestActionGetPayload: payload });
          break;
        default:
        }
    },
    /**
     *
     * @param jqXHR
     * @param textStatus
     * @param errorThrown
     */
    actionTypeGetError: function (jqXHR, textStatus, errorThrown) {
        if (textStatus !== 'abort') { // only handle errors, not intentionally terminated requests
            // do nothing
        }
    },
    /**
     *
     * @returns {boolean}
     */
    retryActionGet: function () {
        // abort failed request
        this.requestActionGetXhr.abort();
        // increment failure counter
        this.set({
            getFailureCount: (parseInt(this.get('getFailureCount'), 10) + 1)
        });

        // handle failure polling limit
        if (this.get('getFailureCount') >= this.get('getFailureLimit')) {
            PubSub.trigger('navigate','error/generic');
            PubSub.trigger('resetAll');
            return false;
        }
        // retry
        this.requestActionGet();
    },
    /**
     *
     */
    requestActionSweeps: function(data) {
        var sweepsData = data;

        var submissionData = _.extend(
            this.getContextData(), 
            { 
                apiKey: this.get('apiKey'),
                action_type: 'sweeps' 
            }, 
            this.getUserData(),
            sweepsData
        );

        var params = this.paramsLiteralToQsp(submissionData);
        var b64hash = this.qspToHash(params);

        var xhrParams = {
            url: this.apiUrl + '?' + params,
            type: 'POST',
            crossDomain: true,
            dataType: 'json',
            data: 'Authorization=' + encodeURIComponent(b64hash),
            success: this.actionTypeSweepsSuccess.bind(this),
            error: this.actionTypeSweepsError.bind(this)
        };

        this.requestActionSweepsXhr = $.ajax(xhrParams);
    },
    /**
     *
     */
    actionTypeSweepsSuccess: function(data, textStatus, jqXHR) {
        // if we don't get any valid data
        if(!(_.isObject(data) && _.size(data) > 0)){
            this.actionTypeSweepsError();
            return false;
        }

        // silently prepare for next vote request
        this.set({requestActionVotePayload: null, shareString: null}, {silent: true});

        // use payload to update app
        var voteString = (!_.isUndefined(data.voteString) && data.voteString.length > 0 ? JSON.parse(data.voteString) : '');
        var shareString = (!_.isUndefined(data.shareString) && data.shareString.length > 0 ? JSON.parse(data.shareString) : '');

        this.set({
            requestActionVotePayload: ( _.isObject(voteString) === true ? _.omit(voteString, 'total') : {} ),
            shareString: ( _.isObject(shareString) === true ? _.omit(shareString, 'total') : {} )
        });

        // HANDLE THE SUCCESS VALUE
        switch(data.response_code) {
            case '20':
                PubSub.trigger('sweepsSuccess', data);
                break;
            case '21':
                // display the user vote error as they have already voted for the category
                PubSub.trigger('sweepsSuccess', data);
                break;
            default:
                this.actionTypeSweepsError();
                break;
        }
    },
    /**
     *
     */
    actionTypeSweepsError: function(jqXHR, textStatus, errorThrown) {
        PubSub.trigger('directRoute', 'error', 'generic');
    },
    /**
     *
     */
    requestActionVote: function (data) {
        // Always pad to at least 2 digits.
        const numDigits = Math.max( this.numberOfCategories.toString().length, 2 );

        var voteData = _.extend({
            category: 'cat'+ padCategoryIndex( data.categoryID, numDigits )
        }, data.categoryVoteData);

        if( data.totalAllocatedVotes !== undefined ) {
            voteData = _.extend( voteData, {
                total: data.totalAllocatedVotes
            });
        }
        
        var dataObj = _.extend(this.getContextData(), { apiKey: this.get('apiKey'), action_type: 'vote' }, this.getUserData(), voteData);

        var params = this.paramsLiteralToQsp(dataObj);
        var b64hash = this.qspToHash(params);

        var xhrParams = {
            url: this.apiUrl + '?' + params,
            type: 'POST',
            crossDomain: true,
            dataType: 'json',
            data: 'Authorization=' + encodeURIComponent(b64hash),
            success: this.actionTypeVoteSuccess.bind(this, voteData),
            error: this.actionTypeVoteError.bind(this)
        };

        PubSub.trigger( 'submittingVote', voteData );
                
        this.requestActionVoteXhr = $.ajax(xhrParams);
    },
    /**
     *
     * @param data
     * @param textStatus
     * @param jqXHR
     */
    actionTypeVoteSuccess: function (voteData, response, textStatus, jqXHR) {
        // if we don't get any valid data
        if(!(_.isObject(response) && _.size(response) > 0)){
            this.actionTypeVoteError();
            return false;
        }

        // silently prepare for next vote request
        this.set({requestActionVotePayload: null, shareString: null}, {silent: true});

        // use payload to update app
        var voteString = (!_.isUndefined(response.votestring) && response.votestring.length > 0 ? unpadVoteStringCategoryIds( response.votestring ) : '');
        var shareString = (!_.isUndefined(response.shareString) && response.shareString.length > 0 ? JSON.parse(response.shareString) : '');

        if( voteString ) {
            response.votestring = JSON.stringify( voteString );
        }

        this.set({
            requestActionVotePayload: ( _.isObject(voteString) === true ? _.omit(voteString, 'total') : {} ),
            shareString: ( _.isObject(shareString) === true ? _.omit(shareString, 'total') : {} )
        });

        // HANDLE THE SUCCESS VALUE
        switch(response.response_code) {
            case '20':
                // update the vote option to have the "voted" text on it
                // route user to next category after '2' seconds
                PubSub.trigger('voteSuccess', response, voteData);
                break;
            case '21':
                // display the user vote error as they have already voted for the category
                PubSub.trigger('voteSuccess', response, voteData);
                break;
            // case '40':
            //     PubSub.trigger('directRoute', 'window');
                // this.controller.closeWindow();
                // break;
            default:
                this.actionTypeVoteError();
                break;
        }
    },
    /**
     *
     * @param jqXHR
     * @param textStatus
     * @param errorThrown
     */
    actionTypeVoteError: function (jqXHR, textStatus, errorThrown) {

        //still set vote temp to null if there's an error
        // var optionId = this.controller.Collections.VoteOption.getSelected().get('id');

        // this.controller.Collections.VoteOption.get(optionId).set({voteCountTemp: null});
        PubSub.trigger('directRoute', 'error', 'voting');
        // this.controller.Routers.Router.navigate('error/voting', {trigger: true});

        this.set({requestActionVoteError: true});
    },

    getEvery: function( interval ) {
        const sanitizedInterval = Math.max( interval, 5000 );
        this.stopGetting();

        this.requestActionGet().then( function() {
            this.getIntervalTimer = setTimeout(function() {
                this.getEvery( sanitizedInterval );
            }.bind(this), sanitizedInterval );

        }.bind(this));
    },

    stopGetting: function() { 
        clearTimeout( this.getIntervalTimer );
    }
});

function unpadVoteStringCategoryIds( voteString ) {
    const voteHistory = JSON.parse(voteString);
    const unpaddedHistory = {};

    Object.keys( voteHistory ).forEach( (catId) => {
        const unpaddedId = unpadCategoryId( catId );
        unpaddedHistory[ unpaddedId ] = voteHistory[ catId ];
    });

    return unpaddedHistory;
}

function padCategoryIndex( index, numDigits ) {
    const strIndex = index + '';
    return strIndex.padStart( numDigits, '0' );
}

function unpadCategoryId( catId ) {
    const pattern = new RegExp(/^cat([0-9]+)$/);
    const results = catId.match( pattern );

    if( results ) {
        const index = parseInt( results[1], 10 );
        return 'cat' + index;
    } else {
        return catId;
    }
}


// WEBPACK FOOTER //
// ./app/scripts/models/connect.js